import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-external',
  templateUrl: './external.component.html',
  styleUrls: []
})
export class ExternalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    console.log("external.component");
  }

}
